import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./IconWrapper.module.scss";
export const IconWrapper = ({ customIcon, icon: Icon }) => {
    if (customIcon) {
        return customIcon;
    }
    if (!Icon) {
        return null;
    }
    return (_jsx("div", { className: styles.iconWrapper, children: _jsx(Icon, {}) }));
};
//# sourceMappingURL=IconWrapper.js.map